import Immutable from 'immutable';

// constants
import { APPOINTMENT_CREATE, APPOINTMENT_LIST_FETCH } from '../constants/appointmentTypes';
import { BLOCK_REP, REP_LIST_FETCH, REP_LIST_UPDATE, SEARCH_REP, SEND_MESSAGE, UNBLOCK_REP, ACTIVATE_REP } from '../constants/repTypes';

// lib
import httpReducer from '../lib/httpReducer';
import mapReducer from '../lib/mapReducer';
import { callbackHandler, merge, replace } from '../lib/mapReducerHelpers';

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case APPOINTMENT_LIST_FETCH:  return mapReducer(state, action, callbackHandler(merge, 'rep'));
    case REP_LIST_FETCH:          return httpReducer(state, action, callbackHandler(merge, 'rep'));
    case REP_LIST_UPDATE:         return mapReducer(state, action, callbackHandler(replace, 'rep'));
    case SEARCH_REP:              return httpReducer(state, action, callbackHandler(merge, 'rep'));
    case BLOCK_REP:               return httpReducer(state, action, callbackHandler(replace, 'rep'));
    case UNBLOCK_REP:             return httpReducer(state, action, callbackHandler(replace, 'rep'));
    case ACTIVATE_REP:             return httpReducer(state, action, callbackHandler(replace, 'rep'));
    case APPOINTMENT_CREATE:       return httpReducer(state, action, callbackHandler(replace, 'rep'));
    default:                      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/rep.js